import React from 'react';


const Popup = ({
    children,
    loading, loadingComponent,
    className = '', visible = true,
}) => (
    visible
        ? <div className={`${className} popup-window popup-size-form`}>
            <div className="logo-wrapper">
                <div className="art-logo"/>
            </div>
            {loading && loadingComponent}
            {!loading && children}
        </div>
        : null

);

export default Popup;



// WEBPACK FOOTER //
// ./src/arteia-js/components/Popup/index.js